export default __webpack_public_path__ + "static/media/L3.a85dd0e5.webp";